export const environment = {
  production: false,
  serviceWorker: true,
  apiUrl: '/api',
};
